// Les mots de l'interface qu'on choisit une fois pour toutes, à un seul endroit.

// Le nom de la base de connaissance de l'entreprise : ce qu'elle sait d'elle-même (identité, références, équipe,
// partenaires, moyens, sections types), repris en tête de chaque mémoire.
export const NOM_BASE = "Socle";

// Les rôles de départ d'un agent de l'entreprise : « nouveau » les propose, chacun pré-remplit le compositeur.
export const ROLES: { nom: string; texte: string }[] = [
  {
    nom: "Auditeur de projets",
    texte:
      "Fais le tour des projets en cours : échéance de remise, avancement du mémoire, analyse faite ou non. Dis-moi ce qui presse et ce qui manque.",
  },
  {
    nom: `Mise à jour du ${NOM_BASE}`,
    texte: `Relis le ${NOM_BASE} de l'entreprise : qu'est-ce qui est vide, ancien ou incomplet ? Propose les fiches à compléter, puis complète-les.`,
  },
  {
    nom: "Rédacteur de sections types",
    texte:
      "Repère, dans les mémoires des projets, les passages qui reviennent d'un projet à l'autre, et écris-en des sections types réutilisables.",
  },
  {
    nom: "Veille des références",
    texte:
      "Vérifie les références passées : sont-elles à jour, bien classées, avec leurs montants et leurs dates ? Ajoute ce qui manque à partir des projets terminés.",
  },
];
